export default __webpack_public_path__ + "static/media/weekday.0927ff51.svg";